module.exports = __webpack_public_path__ + "img/refuse-result.317bff12.png";